// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/parts.php
import Rule from 'offline/filter/core/search/rule'

export default {
	name: 'collection.parts',
	priority: 80,
	require: function(config, filter) {
		return filter.collection && filter.collection.parts && filter.collection.parts.text && filter.collection.parts.text.length > 0
	},
	run: function(config, filter, data, query) {
		var keywords = Rule.getKeywords(filter.collection.parts.text)
		var mode = filter.collection.parts.mode
		for (var i = 0; i < keywords.length; i++) {
			var keyword = '%' + keywords[i] + '%'
			if (mode === 'has') {
				query.where('c.collection_hasparts_text', 'like', keyword)
			} else if (mode === 'want') {
				query.where('c.collection_wantparts_text', 'like', keyword)
			} else {
				query.whereGroup('OR', [
					['c.collection_hasparts_text', 'like', keyword],
					['c.collection_wantparts_text', 'like', keyword]
				])
			}
		}
	}
}
